import { useEffect, useState } from "react";
import { api, useAuth } from "@/auth/AuthContext";

export function useCommunityLinks() {
  const { user } = useAuth();
  const [links, setLinks] = useState(null);
  useEffect(() => {
    if (!user) { setLinks(null); return; }
    api.get("/community/links").then(({ data }) => setLinks(data)).catch(() => setLinks(null));
  }, [user]);
  return links;
}
